import { QueryClient } from '@tanstack/react-query'

/**
 * Shared QueryClient singleton.
 *
 * Exported from its own module (rather than created inline in App.jsx) so
 * non-React code — e.g. BOOKING_CONSTRAINTS in constants/booking.js — can read
 * cached query data via queryClient.getQueryData([...]).
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,
            gcTime: 5 * 60 * 1000,
        },
    },
})

export default queryClient
